module.exports = __webpack_public_path__ + "images/assets/b9beb60b819491ea09fef9f924bad571.svg";